// extracted by mini-css-extract-plugin
module.exports = {"separator":"Breadcrumb_separator__cDpDO","breadcrumb":"Breadcrumb_breadcrumb__eIzC2","contrast":"Breadcrumb_contrast__1b1rj"};